import React from "react";
import style from "./index.module.scss";
import { Checkbox } from "antd";
import { OptionItem, TopicsItem } from "../../../../../../../API/exercise";
import StuAnswerObj from "../../../Question/components/StuAnswerObj";

interface PageCheckBoxProps {
    index?: number;
    data: TopicsItem;
    stuDoFlg: string;
}

export default function PageCheckBoxDetail({
    data,
    index,
    stuDoFlg
}: PageCheckBoxProps) {
    return (
        <div className={style.root}>
            <div>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（多选题，{data.score}分）</span>
            </div>
            <div className={style.title}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: data.contentText
                    }}
                />
            </div>
            <div className={style.options}>
                <Checkbox.Group value={JSON.parse(data.stuAns)} disabled>
                    {data.options &&
                        data.options.map((item: OptionItem, index: number) => (
                            <Checkbox
                                value={item.id}
                                key={index}
                                className={style.radioStyle}>
                                <span className={style.letter}>
                                    {String.fromCharCode(65 + index)}.
                                </span>
                                <span
                                    className={style.spanHtml}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Checkbox>
                        ))}
                </Checkbox.Group>
            </div>
            <StuAnswerObj stuDoFlg={stuDoFlg} data={data} />
        </div>
    );
}
